function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-2 {\n        fill: #414042;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 422.92,
  cy: 67.61,
  fx: 422.92,
  fy: 67.61,
  r: 378.31,
  gradientTransform: "translate(0 55.04) scale(1 .19)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fefcf5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#fdf4da"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#fce7af"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fce39f"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "header_fotter",
  "data-name": "header &amp; fotter"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 13.17,
  y: 0,
  width: 2.55,
  height: 28.12
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m39.55,15.83c.54-.23.79-.84.57-1.38-.23-.54-.84-.79-1.38-.57l-11.74,4.92c-.32-.34-.69-.57-1.11-.62l-16.91-1.07c-1.81.03-3.64.12-4.34,1.82l-.11.27-.45-.19c-.9-.37-1.92.06-2.29.96L.13,24.05c-.37.9.06,1.92.96,2.29l.45.19-.09.23c-.7,1.7.39,3.22,1.82,4.34l12.79,11.13c.39.28.85.39,1.33.36l4.92,11.74c.23.54.84.79,1.38.57.54-.23.79-.84.57-1.38l-4.92-11.72c.46-.37.83-.84,1.05-1.38l7.31-17.87c.23-.56.27-1.19.17-1.8l11.67-4.89ZM4.19,20.06l-2.3,5.62-.45-.19c-.43-.18-.63-.67-.46-1.09l1.66-4.06c.18-.43.67-.63,1.09-.46l.45.19Z"
})), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "786.86 0 423.83 .09 423.83 0 77.07 0 27.67 20.81 19.25 41.78 58.97 135.23 422 135.14 422 135.23 768.76 135.23 818.16 114.41 826.58 93.45 786.86 0"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 830.11,
  y: 107.11,
  width: 2.55,
  height: 28.12
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m806.28,119.4c-.54.23-.79.84-.57,1.38.23.54.84.79,1.38.57l11.74-4.92c.32.34.69.57,1.11.62l16.91,1.07c1.81-.03,3.64-.12,4.34-1.82l.11-.27.45.19c.9.37,1.92-.06,2.29-.96l1.66-4.06c.37-.9-.06-1.92-.96-2.29l-.45-.19.09-.23c.7-1.7-.39-3.22-1.82-4.34l-12.79-11.13c-.39-.28-.85-.39-1.33-.36l-4.92-11.74c-.23-.54-.84-.79-1.38-.57-.54.23-.79.84-.57,1.38l4.92,11.72c-.46.37-.83.84-1.05,1.38l-7.31,17.87c-.23.56-.27,1.19-.17,1.8l-11.67,4.89Zm35.37-4.23l2.3-5.62.45.19c.43.18.63.67.46,1.09l-1.66,4.06c-.18.43-.67.63-1.09.46l-.45-.19Z"
}))));

function SvgHeaderLights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 845.83 135.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLights);
export default __webpack_public_path__ + "static/media/header-lights.3cb8598a7730160ee0ff173743ceff69.svg";
export { ForwardRef as ReactComponent };